module.exports = __webpack_public_path__ + "static/img/YMG.80bf620.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YMG.png
// module id = 350f
// module chunks = 1